import { FormGroup } from "@angular/forms";
import { ValidatorFn } from "@angular/forms";

/**
 * Compare two form inputs to see if they match or not
 */
export function confirmationValidator(originalFieldName: string, confirmationFieldName: string): ValidatorFn {
  return (formGroup: FormGroup) => {
    const originalControl = formGroup.get(originalFieldName);
    const confirmationControl = formGroup.get(confirmationFieldName);

    // Verify we have the controls...
    if (!originalControl || !confirmationControl) {
      console.warn("Invalid original/confirmation control name(s)", {
        originalFieldName: originalControl, confirmationFieldName: confirmationControl
      });
      return null;
    }

    // Ignore if previous errors
    if (confirmationControl.errors && !confirmationControl.errors.confirmation) {
      return null;
    }

    // Set error on matchingControl if validation fails
    if (originalControl.value !== confirmationControl.value) {
      confirmationControl.setErrors({ confirmation: true });
    } else {
      confirmationControl.setErrors(null);
    }
    return null;
  };
}
